module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mai-badge",
    on: {
      "click": function($event) {
        return _vm.$emit('clicked')
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.badge.val) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6983a478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteBadge.vue
// module id = 2210
// module chunks = 1